import list from './list'
import create from './create'
import edit from './edit'
import icon from '@material-ui/icons/Person'

export default { list, create, edit, icon, options: { label: 'Imports' } }
